import {
    IDialogAction,
    IDialogStates,
    DIALOG_ACTION_TYPE,
    IUplevelDepartment,
    ISelectedMap,
    IExcludeMap,
} from './dialogContext';
import update from 'immutability-helper';
import { IListItem } from '@umu/umu-types';
import { onDisablePermissionSwitch } from './utils';

export function DialogReducer(state: IDialogStates, action: IDialogAction): IDialogStates {
    const selectedMap = state.selectedMap;
    const excludeMap = state.excludeMap;
    const dataList = state.dataList;
    const pageInfo = state.pageInfo;

    switch (action.type) {
        case DIALOG_ACTION_TYPE.SET_DEFAULT_SELECTED_LIST: {
            const { defaultSelectedList, defaultExcludeList, defaultSelectedDepartmentList } = action.payload;
            const newSelectedMap: ISelectedMap = {};
            const newExcludeMap: IExcludeMap = {};
            const newFilterMap: Record<string, string[]> = {};

            defaultSelectedList.forEach((i: any) => {
                if (i) {
                    newSelectedMap[i] = {} as IListItem;
                }
            });
            defaultExcludeList.forEach((i: string) => {
                if (i) {
                    newExcludeMap[i] = i;
                }
            });
            // 保存筛选映射，提取缓存的企业名
            let cachedEnterpriseName = '';
            if (defaultSelectedDepartmentList) {
                defaultSelectedDepartmentList.forEach((dept: { id: string; exclude_umu_ids: string[]; oriData?: any }) => {
                    if (dept.exclude_umu_ids?.length) {
                        newFilterMap[dept.id] = dept.exclude_umu_ids;
                    }
                    if (!cachedEnterpriseName && dept.oriData?.enterprise_show_name) {
                        cachedEnterpriseName = dept.oriData.enterprise_show_name;
                    }
                });
            }
            const updateSpec: any = {
                excludeMap: { $set: newExcludeMap },
                selectedMap: { $set: newSelectedMap },
                selectedOrder: { $set: defaultSelectedList.filter(Boolean) },
                filterDepartmentMap: { $set: newFilterMap },
            };
            if (cachedEnterpriseName && !state.enterpriseName) {
                updateSpec.enterpriseName = { $set: cachedEnterpriseName };
            }
            return update(state, updateSpec);
        }

        case DIALOG_ACTION_TYPE.UPDATE_SELECTED_MAP: {
            const _selectedMap: { [key: string]: IListItem } = {};
            (action.payload.list || []).forEach((item: IListItem) => {
                _selectedMap[item.id] = item;
            });
            return update(state, {
                selectedMap: { $set: _selectedMap },
            });
        }

        case DIALOG_ACTION_TYPE.SET_DEFAULT_SELECTED_DATAINFO: {
            const infoList: IListItem[] = action.payload.list || [action.payload.info];
            const mergedSelectedMap = { ...selectedMap };
            infoList.forEach((item: IListItem) => {
                if (item?.id) {
                    mergedSelectedMap[item.id] = item;
                }
            });
            return update(state, {
                selectedMap: { $set: mergedSelectedMap },
            });
        }

        case DIALOG_ACTION_TYPE.CLEAN:
            return update(state, {
                selectedMap: { $set: {} },
                selectedOrder: { $set: [] },
                dataList: { $set: dataList.map((data: IListItem) => ({ ...data, isSelected: false })) },
            });

        case DIALOG_ACTION_TYPE.SET_DATALIST: {
            const { isMore, list, currDepartmentId, pInfo } = action.payload;
            const retList: IListItem[] = [];
            const pInfoTemp = {
                count: pInfo?.count || pageInfo.count,
                currentPage: pInfo?.currentPage || pageInfo.currentPage,
                totalPage: pInfo?.totalPage || pageInfo.totalPage,
                size: pInfo?.size || pageInfo.size,
            };
            list.forEach((data: IListItem) => {
                data.isSelected = data.isSelected || !!selectedMap[data.id];
                if (data.isSelected) {
                    const existing = selectedMap[data.id];
                    const filterIds = existing?.oriData?.exclude_umu_ids || state.filterDepartmentMap?.[data.id];
                    if (filterIds?.length && data.oriData) {
                        const total = Number(data.oriData.member_count) || 0;
                        data.oriData.exclude_umu_ids = filterIds;
                        data.oriData.filteredCount = total - filterIds.length;
                    }
                    selectedMap[data.id] = data;
                }
                if (!excludeMap[data.id]) {
                    retList.push(data);
                }
            });
            return update(state, {
                dataList: { $set: isMore ? dataList.concat(retList) : retList },
                currDepartmentId: { $set: currDepartmentId },
                isSearchMode: { $set: false },
                pageInfo: { $set: pInfoTemp },
                ts: { $set: Date.now() },
            });
        }

        case DIALOG_ACTION_TYPE.SET_ALL_LIST_CHECKED: {
            const { isChecked } = action.payload;
            dataList.forEach((data) => {
                const isDisabledCheck = onDisablePermissionSwitch(data.oriData);
                data.isSelected = isDisabledCheck ? false : isChecked;
                isChecked && !isDisabledCheck ? (selectedMap[data.id] = data) : delete selectedMap[data.id];
            });
            return update(state, {
                dataList: { $set: [...dataList] },
            });
        }

        case DIALOG_ACTION_TYPE.SET_DATAITEM: {
            const { item, isAdd, isRadio } = action.payload;
            const currentOrder = [...state.selectedOrder];
            if (isRadio) {
                Object.keys(selectedMap).forEach((key) => delete selectedMap[key]);
                currentOrder.length = 0;
            }
            if (isAdd) {
                selectedMap[item.id] = item;
                if (!currentOrder.includes(item.id)) {
                    currentOrder.push(item.id);
                }
            } else {
                delete selectedMap[item.id];
                const idx = currentOrder.indexOf(item.id);
                if (idx !== -1) {
                    currentOrder.splice(idx, 1);
                }
            }
            dataList.forEach((data) => {
                if (data.id === item.id) {
                    data.isSelected = !!isAdd;
                } else {
                    if (isRadio) {
                        data.isSelected = false;
                        if (selectedMap[data.id]) {
                            delete selectedMap[data.id];
                        }
                    }
                    data.isSelected = data.isSelected || !!selectedMap[data.id];
                }
            });
            return update(state, {
                dataList: { $set: [...dataList] },
                selectedMap: { $set: selectedMap },
                selectedOrder: { $set: currentOrder },
                ts: { $set: Date.now() },
            });
        }

        case DIALOG_ACTION_TYPE.SET_DATASUG: {
            const sug = action.payload.list;
            sug.forEach((data: any) => (data.isSelected = data.isSelected || !!selectedMap[data.id]));
            return update(state, {
                dataList: { $set: sug },
                isSearchMode: { $set: action.payload.isSearchMode },
                ts: { $set: Date.now() },
            });
        }

        case DIALOG_ACTION_TYPE.SET_CACHE: {
            return update(state, {
                departmentCache: { $set: action.payload.departmentCache || state.departmentCache },
                enterpriseName: { $set: action.payload.enterpriseName || state.enterpriseName },
            });
        }

        case DIALOG_ACTION_TYPE.SET_UPLEVEL_DEPARTMENT: {
            const uplevelDepartmentList = action.payload.uplevelDepartmentList || [];
            const uplevelIdMap = action.payload.uplevelIdMap || {};
            const uplevelDepartment: IUplevelDepartment = {};
            uplevelDepartmentList.forEach((i: IListItem) => {
                if (!uplevelDepartment[i.id]) {
                    uplevelDepartment[i.id] = i;
                }
            });
            return update(state, {
                uplevelDepartment: { $set: uplevelDepartment },
                uplevelIdMap: { $set: uplevelIdMap },
            });
        }

        default:
            return state;
    }
}
